var map = {
	"./aboutUs.png": "646d",
	"./bottom.png": "ee29",
	"./bottomWhite.png": "33f1",
	"./businessIntroduction/1.png": "c3b5",
	"./businessIntroduction/2.png": "4ced",
	"./cooperativePartner/1.png": "2cc7",
	"./cooperativePartner/10.png": "1ca2",
	"./cooperativePartner/2.png": "3b75",
	"./cooperativePartner/3.png": "0728",
	"./cooperativePartner/4.png": "bcef",
	"./cooperativePartner/5.png": "d91a",
	"./cooperativePartner/6.png": "6ed8",
	"./cooperativePartner/7.png": "97ca",
	"./cooperativePartner/8.png": "3c8b",
	"./cooperativePartner/9.png": "2b6b",
	"./developmentHistory/1.jpg": "4e35",
	"./developmentHistory/10.jpg": "852a",
	"./developmentHistory/11.jpg": "dc19",
	"./developmentHistory/12.jpg": "8fe9",
	"./developmentHistory/13.jpg": "08fe",
	"./developmentHistory/14.jpg": "708d",
	"./developmentHistory/2.jpg": "b4f6",
	"./developmentHistory/3.jpg": "7f0b",
	"./developmentHistory/4.jpg": "7f1a",
	"./developmentHistory/5.jpg": "6514",
	"./developmentHistory/6.jpg": "cf00",
	"./developmentHistory/7.jpg": "3c67",
	"./developmentHistory/8.jpg": "316f",
	"./developmentHistory/9.jpg": "06b5",
	"./developmentHistory/developmentHistory/1.jpg": "1949",
	"./developmentHistory/developmentHistory/10.jpg": "434b",
	"./developmentHistory/developmentHistory/11.jpg": "1d9c",
	"./developmentHistory/developmentHistory/12.jpg": "b1d1",
	"./developmentHistory/developmentHistory/13.jpg": "e3b4",
	"./developmentHistory/developmentHistory/2.jpg": "1f21",
	"./developmentHistory/developmentHistory/3.jpg": "64d0",
	"./developmentHistory/developmentHistory/4.jpg": "a435",
	"./developmentHistory/developmentHistory/5.jpg": "b13b",
	"./developmentHistory/developmentHistory/6.jpg": "e22a",
	"./developmentHistory/developmentHistory/7.jpg": "751f",
	"./developmentHistory/developmentHistory/8.jpg": "f026",
	"./developmentHistory/developmentHistory/9.jpg": "029c",
	"./enterpriseHonor/1.png": "1dd4",
	"./enterpriseHonor/2.png": "50e0",
	"./home.png": "70ad",
	"./invite/1.jpg": "0365",
	"./invite/2.jpg": "645e",
	"./invite/3.jpg": "23eb",
	"./invite/4.jpg": "1f04",
	"./invite/5.jpg": "bf64",
	"./invite/6.jpg": "cf22",
	"./left.png": "3203",
	"./right.png": "15f0",
	"./rongyuimg/ry1.png": "26b1",
	"./rongyuimg/ry10.jpeg": "9b25",
	"./rongyuimg/ry11.jpeg": "abfa",
	"./rongyuimg/ry12.jpeg": "4261",
	"./rongyuimg/ry2.png": "b316",
	"./rongyuimg/ry3.png": "409c",
	"./rongyuimg/ry4.png": "1c1d",
	"./rongyuimg/ry5.png": "f9e3",
	"./rongyuimg/ry6.png": "bac9",
	"./rongyuimg/ry7.jpeg": "d1bc",
	"./rongyuimg/ry8.jpeg": "7927",
	"./rongyuimg/ry9.jpeg": "77d2",
	"./talentCultivation/1.jpeg": "8297",
	"./talentCultivation/2.jpeg": "f9f6",
	"./talentCultivation/3.jpeg": "5cd5",
	"./talentCultivation/4.jpeg": "99dd",
	"./talentCultivation/5.jpeg": "71ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e107";